import React from 'react';

import ContentPreviewCard from 'components/campaignStreamline/ContentPreviewCard';
import EarningRulePreviewCard from 'components/campaignStreamline/EarningRulePreviewCard';
import { CampaignType, EarningRuleRewardType } from 'config/CustomEnums';
import { returnDefaultValueWhileEmpty } from 'utils/StringUtil';
import CouponSetPreviewCard from 'components/campaignStreamline/CouponSetPreviewCard';
import CouponCampaignEaringRulePreviewCard from 'components/campaignStreamline/CouponCampaignEaringRulePreviewCard';
import {
  CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY,
  CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY
} from 'config/PageAnchorConfig/CampaignAnchorConfig';
import DetailGeneralInfoCard from 'components/campaignStreamline/DetailGeneralInfoCard';
import LinkedCouponDetailCard from 'components/campaignStreamline/LinkedCouponDetailCard';

const ExtraTopSection = ({ detailData }) => {
  const campaignType = detailData.campaignType;
  const earningCampaignRewardType = detailData.linkedEarningRules?.rewardType;
  const couponTemplate = detailData.campaignCouponTemplate || {};

  let showLinkedCoupon = false;
  if (
    couponTemplate?.pk
    && (
      campaignType === CampaignType.couponsCampaign
      || (
        campaignType === CampaignType.earningRulesCampaign
        && earningCampaignRewardType === EarningRuleRewardType.coupons
      )
    )
  ) {
    showLinkedCoupon = true;
  };

  const displayInFrontend = detailData.displayInFrontend;
  return <>
    {showLinkedCoupon && <LinkedCouponDetailCard couponSet={couponTemplate} />}
    <div
      id={CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.contentPage}
      className='create-campaign-preview-page-extra-top-section'
    >
      <label
        id={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.displayInFrontend.sectionKey}
        className="create-section-title"
      >
        DISPLAY THIS CAMPAIGN IN FRONTEND
      </label>
      <span className='create-campaign-preview-page-extra-top-value'>
        {returnDefaultValueWhileEmpty(displayInFrontend, true) ? "Yes" : "No"}
      </span>
      <div className='create-campaign-preview-page-split-line' />
    </div>
  </>
};


export const CAMPAIGN_DETAIL_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ detailData }) => {
    const campaignType = detailData.campaignType;
    const haveCreatedCoupon = detailData.haveCreatedCoupon;
    const EarningCampaignRewardType = detailData.linkedEarningRules?.rewardType;
    const showCouponTemplateReview = !haveCreatedCoupon &&
      (campaignType === CampaignType.couponsCampaign ||
        (campaignType === CampaignType.earningRulesCampaign &&
          EarningCampaignRewardType === EarningRuleRewardType.coupons)
      )

    const displayLanguageSectionComponents = [
      'campaign_content_section_key',
      'campaign_earning_rule_section_key',
    ];

    if (showCouponTemplateReview) {
      displayLanguageSectionComponents.push('campaign_coupon_section_key');
    }
    displayLanguageSectionComponents.push('campaign_detail_general_section_key');

    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents,
    };
  },
  normalSections: [],
  languageExtraTopSection: ExtraTopSection,
  languageSections: [
    {
      sectionContent: [
        {
          key: 'campaign_content_section_key',
          complexComponent: ({ detailData, language }) => (
            <ContentPreviewCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.earningRulePage,
      sectionTitle: "ruleAndProperties",
      sectionContent: [
        {
          key: 'campaign_earning_rule_section_key',
          complexComponent: ({ detailData, language }) => (
            detailData.campaignType === CampaignType.couponsCampaign ?
              <CouponCampaignEaringRulePreviewCard
                language={language}
                campaignData={detailData}
                hideEditButton
              /> :
              <EarningRulePreviewCard
                language={language}
                campaignData={detailData}
                hideEditButton
              />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.couponPage,
      sectionTitle: "couponContent",
      sectionContent: [
        {
          key: 'campaign_coupon_section_key',
          complexComponent: ({ detailData, language }) => (
            <CouponSetPreviewCard
              language={language}
              couponTemplateData={detailData.campaignCouponTemplate || {}}
              isWithinCreationFlow={false}
              hideEditButton
            />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.detailGeneral,
      sectionContent: [
        {
          key: 'campaign_detail_general_section_key',
          complexComponent: ({ detailData, language }) => (
            <DetailGeneralInfoCard
              language={language}
              campaignData={detailData}
            />
          ),
        },
      ],
    },
  ],
};
